/* ============================================================================
   SUNNY STRIPES — FERTILIZATION & WEED CONTROL PROGRAM BUILDER   added 2026-09-05
   ----------------------------------------------------------------------------
   THERE ARE NO PRICES IN THIS FILE. Every figure comes from assets/ss-rates.js:
   `fert` is priced PER APPLICATION, so a program is that figure times the
   number of applications left in; `grub` is one application. The Book Now
   button gets its variant ids from assets/ss-variants.js, and puts the fert
   product in the cart with a QUANTITY equal to the applications chosen, so the
   cart total is exactly the total on screen.

   WHAT DOES NOT CART
   Typing a square footage prices the real area off the marginal curve, which
   lands on figures no product carries; 3+ acres is quoted per property. Both
   get the lead form and no button — same rule as every other builder.
   ============================================================================ */
(function () {
  "use strict";

  var SS = window.SS_RATES;
  if (!SS) {
    console.error("Sunny Stripes: ss-rates.js did not load — the fertilization builder " +
                  "cannot price anything. Check that snippets/fert-tool.liquid renders it " +
                  "before this file.");
    return;
  }

  var KLAVIYO = { publicApiKey: "SKBLA9" };
  var r5 = SS.round5;
  var TIERS = SS.tiers;

  var APPS = [
    { n: 1, nm: "Early spring — wake-up feed + crabgrass barrier" },
    { n: 2, nm: "Late spring — growth feed + broadleaf control" },
    { n: 3, nm: "Summer — light, balanced feed" },
    { n: 4, nm: "Early fall — recovery feed" },
    { n: 5, nm: "Late fall — winterizer" }
  ];

  var S = { apps: { 1: true, 2: true, 3: true, 4: true, 5: true }, grub: false,
            mode: "cards", lot: "m", sqft: null, sent: false };

  function $(id) { return document.getElementById(id); }
  function money(n) {
    return "$" + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function sqftTxt(n) { return Math.round(n).toLocaleString() + " sq ft"; }
  function tierBy(k) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].k === k) return TIERS[i];
    return null;
  }
  function appCount() {
    var c = 0;
    for (var k in S.apps) if (S.apps[k]) c++;
    return c;
  }

  function area() {
    if (S.mode === "sqft") {
      var v = parseInt(S.sqft, 10);
      return v > 0 ? Math.max(500, v) : null;
    }
    var t = S.lot ? tierBy(S.lot) : null;
    if (!t || t.custom) return null;
    return t.area;
  }
  function isCustom() {
    var t = S.lot ? tierBy(S.lot) : null;
    return !!(S.mode === "cards" && t && t.custom);
  }

  function quote() {
    var a = area(), n = appCount();
    if (a === null) return { none: true, custom: isCustom(), apps: n, total: 0, lines: [] };
    var per  = r5(SS.price("fert", a));
    var grub = r5(SS.price("grub", a));
    var lines = [];
    if (n) lines.push({ svc: "fert", nm: n + " application" + (n === 1 ? "" : "s"), each: per, qty: n, amt: per * n });
    if (S.grub) lines.push({ svc: "grub", nm: "Grub control", each: grub, qty: 1, amt: grub });
    var total = 0;
    for (var i = 0; i < lines.length; i++) total += lines[i].amt;
    return { none: false, custom: false, area: a, apps: n, per: per, grub: grub, lines: lines, total: total,
             atMin: SS.atMin("fert", a), big: a >= 25000 };
  }

  /* ---- size chips ---------------------------------------------------------- */
  function buildLots() {
    var host = $("ftlots"), html = "", i, t;
    for (i = 0; i < TIERS.length; i++) {
      t = TIERS[i];
      html += '<button type="button" class="ftlot' + (S.lot === t.k ? " sel" : "") + '" data-k="' +
              t.k + '"><b>' + t.nm + "</b><span>" + (t.sz || "") + "</span></button>";
    }
    host.innerHTML = html;
  }

  /* ---- render -------------------------------------------------------------- */
  function render() {
    var q = quote(), a = area(), n = q.apps;

    /* application cards */
    var cards = $("ftapps").querySelectorAll(".ftapp");
    for (var i = 0; i < cards.length; i++) {
      var on = !!S.apps[cards[i].getAttribute("data-app")];
      cards[i].classList.toggle("on", on);
      cards[i].classList.toggle("off", !on);
      cards[i].setAttribute("aria-pressed", on ? "true" : "false");
    }

    /* size ui */
    $("ftsqftRow").classList.toggle("show", S.mode === "sqft");
    $("ftlots").style.display = S.mode === "cards" ? "" : "none";
    $("ftmodeCards").classList.toggle("on", S.mode === "cards");
    $("ftmodeSqft").classList.toggle("on", S.mode === "sqft");

    if (q.custom) {
      $("ftRead").innerHTML = "Over three acres we walk the property and quote the program per site.";
    } else if (a === null) {
      $("ftRead").innerHTML = S.mode === "sqft" ? "Enter the square footage of lawn." : "Pick a size to see your price.";
    } else {
      $("ftRead").innerHTML = "Pricing <b>" + sqftTxt(a) + "</b> of turf — <b>" + money(q.per) + "</b> per application.";
    }

    var flag = $("ftFlag"), flagTxt = "";
    if (q.custom) {
      flagTxt = "Tell us about the property and we'll walk it, measure it and put a program price in writing.";
    } else if (!q.none && q.atMin) {
      flagTxt = "This is our minimum per application: below a certain size the trip is most of the cost, so the price stops falling.";
    } else if (!q.none && q.big) {
      flagTxt = "Large lawn — we may split an application across two visits. We'll say so before we start.";
    }
    flag.innerHTML = flagTxt;
    flag.classList.toggle("show", !!flagTxt);

    /* grub add-on */
    $("ftGrub").classList.toggle("on", S.grub);
    $("ftGrub").setAttribute("aria-pressed", S.grub ? "true" : "false");
    $("ftGrubAmt").innerHTML = a === null
      ? "&mdash;<small>one application</small>"
      : money(q.grub) + "<small>one application</small>";

    /* the ledger */
    $("ftCardSub").textContent = n === 5 ? "Full season, five applications"
      : n === 0 ? "No applications selected" : n + " of 5 applications";
    var html = "";
    if (!q.none) {
      for (i = 0; i < q.lines.length; i++) {
        var L = q.lines[i];
        html += '<div class="ftrow"><span>' + L.nm + "</span><span>" + money(L.amt) + "</span></div>";
        if (L.qty > 1) html += '<div class="ftrow ftmath"><span>' + L.qty + " × " + money(L.each) + "</span><span></span></div>";
      }
    }
    $("ftLines").innerHTML = html;
    $("ftTotal").textContent = q.none ? (q.custom ? "Custom" : "$0") : money(q.total);
    $("ftPer").textContent = (!q.none && n > 0)
      ? "Billed per application as each one goes down — " + money(q.per) + " each" +
        (S.grub ? ", grub control with the early-summer visit." : ".")
      : "";

    /* book / ask */
    var book = $("ftBook"), note = "", url = cartUrl(q);
    if (url) {
      book.style.display = "";
      book.disabled = false;
      book.textContent = "Book the program →";
      book.setAttribute("data-cart", url);
      note = "Booking reserves your spot on the route at this price. We confirm the start date before the first application, and you can cancel any time before it.";
    } else {
      book.style.display = "none";
      if (n === 0) note = "Leave at least one application in to see a price.";
      else if (q.custom) note = "Three acres and up is quoted per property — send this through and we'll scope it.";
      else if (S.mode === "sqft" && a !== null) note = "This price is worked out from the square footage you typed rather than a size band, so we confirm it before booking. Send it through, or pick a size band to book online.";
    }
    $("ftNote").textContent = note;
    $("ftNote").style.display = note ? "" : "none";
  }

  function cartUrl(q) {
    var V = window.SS_VARIANTS;
    if (!V || q.none || S.mode !== "cards" || !S.lot || isCustom() || !q.lines.length) return null;
    var items = [], i, sku;
    for (i = 0; i < q.lines.length; i++) {
      sku = V.skuFor(q.lines[i].svc, S.lot);
      if (!sku || !V.has(sku)) return null;
      items.push({ sku: sku, qty: q.lines[i].qty });
    }
    return V.cartUrl(items);
  }

  /* ---- lead ---------------------------------------------------------------- */
  function pad(s) { while (s.length < 26) s += " "; return s; }
  function leadSummary(p, q) {
    var L = [];
    L.push("FERTILIZATION & WEED CONTROL PROGRAM QUOTE");
    L.push("");
    L.push("  Name     " + (p.first_name + " " + p.last_name).trim());
    L.push("  Email    " + p.email);
    L.push("  Phone    " + (p.phone_number || "—"));
    L.push("  Address  " + [p.address, p.city, p.zip].filter(Boolean).join(", "));
    L.push("");
    L.push("  Lawn     " + (q.custom ? "3+ acres (custom)" : q.none ? "not given" : sqftTxt(q.area)) +
           (S.mode === "sqft" ? "  (typed)" : S.lot ? "  (" + (tierBy(S.lot) || {}).nm + ")" : ""));
    L.push("  Applications in:");
    for (var i = 0; i < APPS.length; i++) {
      L.push("    " + (S.apps[APPS[i].n] ? "[x] " : "[ ] ") + APPS[i].nm);
    }
    if (!q.none) {
      L.push("");
      L.push("  " + pad("Per application") + money(q.per));
      for (i = 0; i < q.lines.length; i++) L.push("  " + pad(q.lines[i].nm) + money(q.lines[i].amt));
      L.push("  " + pad("SEASON TOTAL") + money(q.total));
    }
    return L.join("\n");
  }
  function phoneE164(p) {
    var d = String(p || "").replace(/\D/g, "");
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d.charAt(0) === "1") return "+" + d;
    return null;
  }
  function postForm(id, fields) {
    var f = $(id);
    if (!f) return false;
    Object.keys(fields).forEach(function (k) {
      var el = f.querySelector('[name="' + k + '"]');
      if (el) el.value = fields[k];
    });
    try {
      if (window.Shopify && Shopify.captcha && Shopify.captcha.protect) {
        Shopify.captcha.protect(f, function () { try { f.submit(); } catch (e) {} });
        return true;
      }
    } catch (e) {}
    var b = f.querySelector('[type="submit"]');
    if (b) { b.click(); return true; }
    if (f.requestSubmit) { f.requestSubmit(); return true; }
    f.submit();
    return true;
  }
  function klaviyo(metricName, p, props) {
    if (!KLAVIYO.publicApiKey) return;
    try {
      var prof = { email: p.email, first_name: p.first_name, last_name: p.last_name };
      var e164 = phoneE164(p.phone_number);
      if (e164) prof.phone_number = e164;
      fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(KLAVIYO.publicApiKey), {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({ data: { type: "event", attributes: {
          metric: { data: { type: "metric", attributes: { name: metricName } } },
          properties: props,
          profile: { data: { type: "profile", attributes: prof } }
        } } })
      })["catch"](function () {});
    } catch (e) {}
  }

  function send() {
    if (S.sent) return;
    var p = {
      first_name: $("ftfname").value.trim(), last_name: $("ftlname").value.trim(),
      email: $("ftemail").value.trim(), phone_number: $("ftphone").value.trim(),
      address: $("ftaddr").value.trim(), city: $("ftcity").value.trim(), zip: $("ftzip").value.trim(),
      optin: $("ftoptin").checked
    };
    var err = $("fterr");
    if (!p.first_name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(p.email)) {
      err.textContent = "A first name and a working email, and we'll take it from there.";
      err.classList.add("show");
      return;
    }
    err.classList.remove("show");

    var q = quote();
    var reference = "FT-" + Date.now().toString(36).toUpperCase();
    var appsIn = [];
    for (var i = 0; i < APPS.length; i++) if (S.apps[APPS[i].n]) appsIn.push(APPS[i].n);

    if (/^https?:$/.test(location.protocol)) {
      try {
        if (p.optin) {
          postForm("ssCustomerForm", {
            "contact[first_name]": p.first_name, "contact[last_name]": p.last_name,
            "contact[email]": p.email, "contact[tags]": "Fert Lead"
          });
        }
        postForm("ssLeadForm", {
          "contact[name]": (p.first_name + " " + p.last_name).trim(),
          "contact[email]": p.email, "contact[phone]": p.phone_number,
          "contact[body]": leadSummary(p, q)
        });
        klaviyo("Quote Requested", p, {
          tool: "fert", reference: reference,
          applications: appsIn, application_count: appsIn.length, wants_grub: S.grub,
          lawn_sqft: q.none ? null : q.area,
          size_band: S.mode === "cards" && S.lot ? S.lot : null,
          per_application: q.none ? null : q.per,
          quoted_total: q.none ? null : q.total
        });
      } catch (e) {}
    } else {
      console.log("(preview mode — lead not sent)\n" + leadSummary(p, q));
    }

    S.sent = true;
    $("ftform").classList.remove("show");
    $("ftdone").classList.add("show");
    $("ftdone").scrollIntoView({ behavior: "smooth", block: "center" });
  }

  /* ---- wiring -------------------------------------------------------------- */
  function bind() {
    $("ftapps").addEventListener("click", function (e) {
      var c = e.target.closest ? e.target.closest(".ftapp") : null;
      if (!c) return;
      var k = c.getAttribute("data-app");
      S.apps[k] = !S.apps[k];
      render();
    });
    $("ftGrub").addEventListener("click", function () { S.grub = !S.grub; render(); });
    $("ftlots").addEventListener("click", function (e) {
      var chip = e.target.closest ? e.target.closest(".ftlot") : null;
      if (!chip) return;
      S.lot = chip.getAttribute("data-k");
      buildLots();
      render();
    });
    $("ftmodeCards").addEventListener("click", function () { S.mode = "cards"; render(); });
    $("ftmodeSqft").addEventListener("click", function () { S.mode = "sqft"; render(); $("ftsqft").focus(); });
    $("ftsqft").addEventListener("input", function () { S.sqft = this.value; render(); });
    $("ftBook").addEventListener("click", function () {
      var url = this.getAttribute("data-cart");
      if (!url) return;
      this.disabled = true;
      this.textContent = "Opening your cart…";
      window.location.href = url;
    });
    $("ftAsk").addEventListener("click", function () {
      $("ftform").classList.add("show");
      $("ftform").scrollIntoView({ behavior: "smooth", block: "center" });
    });
    $("ftsend").addEventListener("click", send);
    window.addEventListener("pageshow", function () { render(); });
  }

  buildLots();
  bind();
  render();
})();
